module.exports = __webpack_public_path__ + "assets/img/qyzx_jk_bn.9a3670d3.png";